<template>
    <b-card no-body class="shadow h-100 flex-container grid-stack-item-content">
      <div slot="header">
        <window-header :cmp-title="ident" widget-name="history-diff"></window-header>
      </div>
      <div class="flex-full-height  pr-3 pl-3">
        <b-table fixed hover small :items="recs" :fields="fields">

        </b-table>
      </div>

    </b-card>
</template>

<script>
  import WindowHeader from './common/WindowHeader'
  export default {
    name: 'HistoryDiff',
    components: {WindowHeader},
    props: {
      d: {
        default: () => []
      },
      operation: {
        defalt: null
      },
      ident: {
        defalt: ''
      }
    },
    data () {
      return {
        fields: ['field', 'before', 'after'],
        recs: []
      }
    },
    mounted () {
      let changes = this.d[0] || {}
      let current = this.d[1] || {}


      let rows = []
      Object.keys(this.operation === 'DELETE' ? changes : current).sort((a, b) => a < b ? -1 : 1).forEach(k => {
        let rec = {
          field: k,
          before: typeof changes[k] === 'undefined' ? current[k] : changes[k],
          after: current[k]
        }

        if (this.operation === 'UPDATE' && typeof changes[k] !== 'undefined' ) {
          rec._rowVariant = 'info'
        }

        rows.push(rec)
      })

      this.recs = rows
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HistoryDiff.vue